import './index.scss';
import { PropType, defineComponent, h, reactive, watch } from 'vue';
import { Dialog } from '@phi/components';
import { request_partstudio_body_details } from '@frontend/input_output';
import FormToggle from '@frontend/components/FormToggle';
import ImportingGuidelines from '@frontend/components/ImportingGuidelines';
import Dropdown from '@frontend/components/Dropdown';
import { State } from '@frontend/state';
import { SelectDocumentPartBody } from '@components/OnshapeExplorer';
import { Option } from '@vaaas/fpts/option';
import { AnyBody, PartstudioElement } from '@phi/onshape';
import {
    hide_import_ref_partstudio_modal,
    showing_reference_partstudio_modal as show,
    showing_reference_partstudio_modal,
} from '../state';
import { Label } from '@components/form';

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    setup({ state }) {
        const data = reactive({
            convert: false,
            element: undefined as Option<PartstudioElement>,
            part: undefined as Option<AnyBody>,
            had_selected_document: Boolean(state.document || state.workspace),
        });

        function can_import() {
            return Boolean(
                state.document
                && state.workspace
                && data.element
            );
        }

        function onClose() {
            hide_import_ref_partstudio_modal();
        }

        async function onImport() {
            hide_import_ref_partstudio_modal();
            if (!data.element) return;
            else request_partstudio_body_details(
                data.element.id,
                data.element.name,
                data.part ? data.part.id : data.part,
                '',
                !data.convert,
                data.part === undefined,
            );
        }

        function reset() {
            data.convert = false;
            data.part = undefined;
            data.element = undefined;
            data.had_selected_document = false;
        }

        watch(
            () => showing_reference_partstudio_modal.value,
            (value) => {
                if (value)
                    data.had_selected_document = state.document !== undefined;
                else
                    reset();
            },
        );

        return () => h(Dialog, {
            show: show.value,
            onClose: onClose,
            onConfirm: onImport,
            confirm_enabled: can_import(),
            confirm_label: 'Import',
            id: 'ImportRefPartstudioModal',
            title: 'Import Reference from Part Studio',
        }, () => [
            h('section', h(SelectDocumentPartBody, {
                can_select_document: !data.had_selected_document,
                document: state.document,
                workspace: state.workspace,
                element: data.element,
                part: data.part,
                'onUpdate:document': x => {
                    if (!data.had_selected_document)
                        state.document = x;
                },
                'onUpdate:workspace': x => {
                    if (!data.had_selected_document)
                        state.workspace = x;
                },
                'onUpdate:element': x => data.element = x,
                'onUpdate:part': x => data.part = x,
            })),

            h('hr'),

            h('section', h(Label, { space: 'between' }, {
                label: () => 'Attempt to convert into editable Phi model',
                input: () => h(FormToggle, {
                    value: data.convert,
                    'onUpdate:value': (x) => data.convert = x,
                }),
            })),

            h('section', h(Dropdown, {
                cursor: 'help',
                title: 'ⓘ Helpful tips',
            }, () => h(ImportingGuidelines))),
        ]);
    },
});
